import React, { useState, useEffect, JSX } from "react";
import { useTranslation } from "react-i18next";
import { Drawer as MuiDrawer, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";
import { useDrawerStyles } from "./css";
import { assureArray } from "../utils/validate";
import DataView, { DataViewItemType } from "../components/DataView";

interface IDrawer {
  children?: string | JSX.Element | undefined;
  data?: { [name: string]: any };
  isOpen: boolean;
  onClose: (event: {}) => void;
  onConfirm?: (event: {}) => void;
  iconColor?: "error" | "warning";
  isCloseButton?: boolean;
  isConfirmationButton?: boolean;
  message?: string;
  onExited?: () => void;
  disableRestoreFocus?: boolean;
}

function Drawer(props: IDrawer) {
  const {
    isOpen = false,
    children,
    onClose,
    data,
    onExited,
    disableRestoreFocus,
  } = props;
  const dataArray = data ? Object.entries(data) : [];
  const [translate] = useTranslation();
  const { classes } = useDrawerStyles();
  const [schema, setSchema] = useState<DataViewItemType[]>();

  useEffect(() => {
    if (data && data.schema) {
      const schemaInfo = assureArray(data.schema);
      setSchema(schemaInfo);
    }
  }, [data]);

  return (
    <MuiDrawer
      open={isOpen}
      anchor="bottom"
      elevation={0}
      variant="temporary"
      onClose={onClose}
      disableRestoreFocus={disableRestoreFocus}
      slotProps={{ transition: { onExited } }}
      classes={{ root: classes.root, paper: classes.paper }}
    >
      <div className={classes.closeButton}>
        <IconButton onClick={onClose} size="medium">
          <Close fontSize="medium" className={classes.icon} />
        </IconButton>
      </div>

      {children}
      {schema ? (
        <DataView schema={schema}></DataView>
      ) : dataArray ? (
        <div className={classes.lines}>
          {dataArray.map((item) => {
            return (
              <div key={item[0]}>
                {item[0] === "IMG_LINK" ? (
                  <div className={classes.imageWrapper}>
                    <img
                      src={item[1]}
                      alt="Product Image"
                      className={classes.image}
                    />
                  </div>
                ) : (
                  <div className={classes.container}>
                    <div className={classes.left}>
                      <div className={classes.words}>
                        {translate(
                          item[0].toLowerCase(),
                          item[0].charAt(0).toUpperCase() + item[0].slice(1),
                        )}
                      </div>
                    </div>
                    <div className={classes.right}>
                      <div className={classes.words}>{item[1]}</div>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ) : (
        ""
      )}
    </MuiDrawer>
  );
}

export default Drawer;
